module.exports = __webpack_public_path__ + "static/media/brewtrackr.818b04a4.png";